















































import Modal from "../core/Modals/Modal.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { RecurrenceInterventionApi } from "../api/RecurrenceInterventionApi";
import { RecurrenceIntervention } from "../models/RecurrenceIntervention";
import RecurrenceInterventionModalEdit from "./RecurrenceInterventionModalPartials/RecurrenceInterventionModalEdit.vue";
import moment from "moment";
import Tabs from "../core/Tabs/Tabs.vue";
import Tab from "../core/Tabs/Tab.vue";
import RecurrenceInterventionsSecondairesEdit from "./RecurrenceInterventionModalPartials/RecurrenceInterventionsSecondairesEdit.vue";
import RecurrenceInterventionRemplacementEdit from "./RecurrenceInterventionModalPartials/RecurrenceInterventionRemplacementEdit.vue";
import History from "../core/History/History.vue";

export default {
    name: "InterventionModal",
    components: {
        History,
        RecurrenceInterventionRemplacementEdit,
        RecurrenceInterventionsSecondairesEdit,
        Tab,
        Tabs,
        RecurrenceInterventionModalEdit,
        EditionModal,
        Modal,
    },
    props: {
        recurrenceInterventionId: Number,
        isNew: Boolean,
    },
    data() {
        return {
            showModal: false,
            recurrenceIntervention: null,
            deletedFrequences: [],
            fetching: true,
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
        };
    },
    created() {
        var self = this;
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
            this.$emit("close-modal", this.recurrenceIntervention);
        },
        saveIntervention: function (): Promise<RecurrenceIntervention> {
            let self = this;
            return self.RecurrenceInterventionApi.save(
                self.recurrenceIntervention
            ).then(function (res) {
                let recurrenceInterventionId = res.id;
                let promises = [];
                _.forEach(
                    self.recurrenceIntervention.frequences,
                    function (frequence) {
                        if (frequence.id) {
                            let promise =
                                self.RecurrenceInterventionApi.updateFrequence(
                                    recurrenceInterventionId,
                                    frequence
                                );
                            promises.push(promise);
                        } else {
                            let promise =
                                self.RecurrenceInterventionApi.addFrequence(
                                    recurrenceInterventionId,
                                    frequence
                                );
                            promises.push(promise);
                        }
                    }
                );
                _.forEach(self.deletedFrequences, function (deletedFrequence) {
                    if (deletedFrequence.id) {
                        let promise =
                            self.RecurrenceInterventionApi.removeFrequence(
                                recurrenceInterventionId,
                                deletedFrequence.id
                            );
                        promises.push(promise);
                    }
                });
                return Promise.all(promises).then(function () {
                    swal({
                        title: "Voulez vous appliquer ces changements aux interventions à venir ?",
                        text: "",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn btn-warning",
                        confirmButtonText: "Oui",
                        cancelButtonClass: "btn btn-default",
                        cancelButtonText: "Annuler",
                        buttonsStyling: false,
                    }).then(
                        function () {
                            var inputValue = moment().format("YYYY-MM-DD");

                            swal({
                                title: "Réinitialiser à partir du :",
                                input: "text",
                                inputValue: inputValue,
                                showCancelButton: true,
                                cancelButtonText: "Annuler",
                                inputValidator: function (value) {
                                    return new Promise(function (resolve) {
                                        if (
                                            moment(
                                                value,
                                                "YYYY-MM-DD",
                                                true
                                            ).isValid()
                                        ) {
                                            resolve();
                                        } else {
                                            resolve("Date invalide !");
                                        }
                                    });
                                },
                                onOpen: function (dom) {
                                    let input =
                                        dom.querySelector("input.swal2-input");
                                    input.type = "date";
                                },
                            }).then(
                                function (result) {
                                    self.RecurrenceInterventionApi.resetInterventionRecurrente(
                                        recurrenceInterventionId,
                                        moment(result).format("DD/MM/YYYY")
                                    ).then(function () {
                                        self.$emit(
                                            "data-saved",
                                            self.recurrenceIntervention
                                        );
                                        return res;
                                    });
                                },
                                function (dismiss) {
                                    self.$emit(
                                        "data-saved",
                                        self.recurrenceIntervention
                                    );
                                }
                            );
                        },
                        function (dismiss) {
                            self.$emit(
                                "data-saved",
                                self.recurrenceIntervention
                            );
                        }
                    );
                });
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.create = true;
        },
        onFrequenceDelete: function (frequence): void {
            this.deletedFrequences.push(frequence);
        },
    },
    watch: {
        recurrenceInterventionId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.RecurrenceInterventionApi.get(
                    self.recurrenceInterventionId,
                    {
                        include:
                            "remplacements,interventions_secondaires,history",
                    }
                ).then(function (res) {
                    self.recurrenceIntervention = res;
                    self.deletedFrequences = [];
                    self.fetching = false;
                    self.create = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.recurrenceIntervention = new RecurrenceIntervention(
                        {}
                    );
                    this.deletedFrequences = [];
                    this.creationModal();
                }
            },
        },
    },
};
